// GENERATED FILE — do not edit, do not commit (see .gitignore).
// Written by frontend/scripts/generate-version.js on install and on every build.
export const buildInfo = {
  commit: '24b644a',
  branch: 'prod-new',
  buildDate: '2026-11-04T09:25:59.623Z',
  dirty: true,
} as const;
